/**
 * Validación de formato de RFC — única fuente para los formularios que aceptan
 * RFC. No duplicar el patrón: si cambia, cambia acá.
 */

/** 3-4 letras (incluye Ñ y &), 6 dígitos de fecha y 3 de homoclave. */
export const RFC_REGEX = /^[A-ZÑ&]{3,4}\d{6}[A-Z0-9]{3}$/;

/** Valida el formato de un RFC (no su existencia ni que tenga FIEL cargada). */
export function esRfcValido(rfc: string): boolean {
  return RFC_REGEX.test(rfc.trim().toUpperCase());
}
